export default __webpack_public_path__ + "static/waxfilingdust-a057b5ec4c16fb7ab69d66309fa2f5f9.png";